export type StorageLike = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function readStorage(storage: StorageLike | undefined, key: string): string | null {
  if (!storage) return null;
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(storage: StorageLike | undefined, key: string, value: string): boolean {
  if (!storage) return false;
  try {
    storage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function removeStorage(storage: StorageLike | undefined, key: string): boolean {
  if (!storage) return false;
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

export function browserStorage(): StorageLike | undefined {
  try {
    return typeof globalThis.localStorage === "undefined" ? undefined : globalThis.localStorage;
  } catch {
    return undefined;
  }
}

export function readLocalStorage(key: string): string | null {
  return readStorage(browserStorage(), key);
}

export function writeLocalStorage(key: string, value: string): boolean {
  return writeStorage(browserStorage(), key, value);
}
